define('collections/commons/country',[
    'jquery',
    'underscore',
    'backbone',
    // models
    'models/commons/country',
    // datafiles
    'text!assets/datafiles/countries.json'
], function($, _, Backbone, MCountry, CountriesData) {

    var data = $.parseJSON(CountriesData);

    var CCountry = Backbone.Collection.extend({
        url: 'assets/datafiles/countries.json',
        model: MCountry,
        initialize: function(models, opt) {
            // models = CountriesData;
            this.set(data, { silent: true });
        },
    });

    return CCountry;

});

